<template>
    <div class="route__logs">
        <div class="route__log" v-if="toplistLoading || toplist.length">
            <h3>Flest besøk {{ competitionName }}</h3>
            <p v-if="toplistLoading">Laster...</p>
            <template v-else>
                <div class="table table--routelog">
                    <table>
                        <thead>
                            <tr>
                                <th>Navn</th>
                                <th>Besøk</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="entry in toplistPage" :key="entry.name">
                                <td>{{ entry.name }}</td>
                                <td class="table__num">{{ entry.visits }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="route__paginate">
                    <a href="#" v-if="toplistPageIndex > 0" @click.prevent="toplistPageIndex--">&laquo; Forrige side</a>
                    <a href="#" v-if="hasMore(toplist, toplistPageIndex)" @click.prevent="toplistPageIndex++">Neste side &raquo;</a>
                </div>
            </template>
        </div>

        <div class="route__log" v-if="visitlogLoading || visitlog.length">
            <h3>Besøkslogg</h3>
            <p v-if="visitlogLoading">Laster...</p>
            <template v-else>
                <div class="table table--routelog">
                    <table>
                        <thead>
                            <tr>
                                <th>Dato</th>
                                <th>Antall besøk</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="entry in visitlogPage" :key="entry.route_date">
                                <td>{{ formatVisitDate(entry.route_date) }}</td>
                                <td class="table__num">{{ entry.visits }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="route__paginate">
                    <a href="#" v-if="visitlogPageIndex > 0" @click.prevent="visitlogPageIndex--">&laquo; Forrige side</a>
                    <a href="#" v-if="hasMore(visitlog, visitlogPageIndex)" @click.prevent="visitlogPageIndex++">Neste side &raquo;</a>
                </div>
            </template>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';

const props = defineProps({
    routeId: { type: Number, required: true },
    competitionName: { type: String, default: '' },
});

const PAGE_SIZE = 10;
const MONTH_NAMES = ['jan', 'feb', 'mar', 'apr', 'mai', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'des'];

const toplist = ref([]);
const toplistLoading = ref(true);
const toplistPageIndex = ref(0);

const visitlog = ref([]);
const visitlogLoading = ref(true);
const visitlogPageIndex = ref(0);

function hasMore(list, pageIndex) {
    return (pageIndex + 1) * PAGE_SIZE < list.length;
}

function pageOf(list, pageIndex) {
    return list.slice(pageIndex * PAGE_SIZE, (pageIndex + 1) * PAGE_SIZE);
}

const toplistPage = computed(() => pageOf(toplist.value, toplistPageIndex.value));
const visitlogPage = computed(() => pageOf(visitlog.value, visitlogPageIndex.value));

// route_date arrives as an ISO date string ("2026-08-24") - matches the
// original routelog_visits.twig's "24. aug" style rendering.
function formatVisitDate(routeDate) {
    const date = new Date(routeDate + 'T00:00:00');

    return date.getDate() + '. ' + MONTH_NAMES[date.getMonth()];
}

onMounted(async () => {
    try {
        const response = await fetch('/xhr/frontend/toplists/routes/' + props.routeId, {
            headers: { Accept: 'application/json' },
        });
        if (response.ok) {
            const data = await response.json();
            toplist.value = data.toplist || [];
        }
    } catch (e) {
        // Leave the list empty.
    } finally {
        toplistLoading.value = false;
    }

    try {
        const response = await fetch('/xhr/frontend/routes/' + props.routeId + '/visits', {
            headers: { Accept: 'application/json' },
        });
        if (response.ok) {
            const data = await response.json();
            visitlog.value = data.visitlog || [];
        }
    } catch (e) {
        // Leave the list empty.
    } finally {
        visitlogLoading.value = false;
    }
});
</script>
